import { render, staticRenderFns } from "./FreshlifePromotion.vue?vue&type=template&id=3c403e36&"
import script from "./FreshlifePromotion.vue?vue&type=script&lang=js&"
export * from "./FreshlifePromotion.vue?vue&type=script&lang=js&"
import style0 from "./FreshlifePromotion.vue?vue&type=style&index=0&id=3c403e36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports